export default __webpack_public_path__ + "static/media/plasty.1137121b.svg";